  const loadNegativeMarginImage = () => {

    // This set the min-height of the parent div to the height of the image so the
    // image will always be contained within it
    const negativeMarginElements = document.querySelectorAll('.negative-margin');
      negativeMarginElements.forEach(function(element) {
        const parentDiv = element.parentElement;
        const elementHeight = element.offsetHeight;

        if (parentDiv) {
          parentDiv.style.minHeight = `${elementHeight}px`;
        }
      });
  }
  
  if (document.readyState !== "loading") {
    loadNegativeMarginImage();
  } else {
    document.addEventListener("DOMContentLoaded", loadNegativeMarginImage);
  }
  